/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useState } from 'react';
import App from '../../layout/App';
import {
    FormContent, Container,
    BoxInput, Box, Box2Items,
    Box3Items, Message,
    Select, Option,
    TitleFieldForm, Box50,
    Box25, Box30, Madatory
} from '../../styles/styles';

import InputResponsive1 from '../../Components/InputResponsive1';
import Checkbox from '../../Components/checkbox';
import { useNavigate } from 'react-router-dom';
import api from '../../utils/api'
//usado para a validação dos forms
import { useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import Loading from '../../Components/Loading';
import { onlyNumber, onlyText, cpfMask } from '../../utils/mask'
import './styles.css';
import MessagePopUp from '../../Components/messagePopUp';
import { fillNulls, IsNone } from '../../utils/functions';

import InfoForm from '../../Components/infoForm'
import ButtonFormFooter from '../../Components/buttonFormFooter';
import { MessageContext } from '../../context/message';
import { validationForm1 } from '../../utils/validationStudent';
import { DataUtilsContext } from '../../context/dataUtils';
import { useIndexedLabels } from '../../utils/useIndexedLabels';
import { AlunoJson } from '../../utils/objectJson';


//faltando data validations

function Identificacao() {
    const {
        getTitleIndex,
        getIndexByLabel,
    } = useIndexedLabels();
    const [messageRequired, setMessageRequired] = useState([])
    const [removeLoad, setRemoveLoad] = useState(false)
    const navigation = useNavigate();
    const [aux, setAux] = useState([]);
    const { setErrorMessage } = useContext(MessageContext);
    const [Identificacao, setIdentificacao] = useState()
    const { register, handleSubmit, setValue, formState: { errors } } = useForm({
        resolver: yupResolver(validationForm1)
    });

    const { listCountry, listCity, listUf } = useContext(DataUtilsContext);

    const onSubmit = (data, e) => {
        setRemoveLoad(false)
        e.preventDefault()
        setTimeout(function () {
            sessionStorage.setItem('AlunoEditar', JSON.stringify(Identificacao))
            if (sessionStorage.getItem('AlunoEditar') !== '' || sessionStorage.getItem('AlunoEditar') !== undefined) {
                setRemoveLoad(true)
                navigation('/aluno/editar-dados-pessoais')
            }
        }, 1000);
    };

    useEffect(async () => {
        let aluno = sessionStorage.getItem('AlunoSelecionado')
        api.get('student/' + aluno)
            .then(function (response) {
                const data = fillNulls(response.data, AlunoJson)
                setIdentificacao(data)
            }).catch((error) => {
                setErrorMessage([{ message: "erro ao buscar dados", ok: false }])
            })



        setRemoveLoad(true)
    }, [])


    function setExistsDeficiency(value) {
        setIdentificacao({ ...Identificacao, existsDeficiencyDisorder: Number(value) })
    }

    function setExistsImpactfulLearningDisorder(value) {
        setIdentificacao({ ...Identificacao, existsImpactfulLearningDisorder: Number(value) })
    }


    useEffect(() => {
        if (Identificacao?.uf !== '') {
            const Filtrados = listCity.filter((city) => city.uf.startsWith(Identificacao?.uf))
            setAux(Filtrados)
        }
    }, [Identificacao, listCity])

    useEffect(() => {
        if (errors) {
            const entries = Object.entries(errors).map(([key, error]) => ({
                id: key + '-' + error.message,
                fieldName: key,
                error,
            }));
            setMessageRequired(entries);
        }
    }, [errors]);

    return (
        <>
            {!removeLoad && <Loading />}
            <div className='span-message'>
                {messageRequired.map(({ id, fieldName, error }) => {
                    const idx = getIndexByLabel(fieldName) || "";
                    const text = error.message;

                    return (
                        <MessagePopUp
                            key={id}
                            title={`Campo ${idx} - obrigatório`}
                            text={text}
                            onClose={() =>
                                setMessageRequired(prev => prev.filter(m => m.id !== id))
                            }
                        />
                    );
                })}
            </div>
            <App>

                <Container>
                    <form onSubmit={handleSubmit(onSubmit)} style={{ display: 'flex', gap: '10px', flexDirection: 'column' }} >
                        <InfoForm
                            title="Aluno"
                            wasChanged={Identificacao?.wasChanged}
                            subtitle="Identificação"
                            positionPagination="1/2"
                        />
                        <FormContent>
                            <span hidden={true}
                                register={register("codeBirthDate")}
                                {...setValue('codeBirthDate', Identificacao?.aclass.stage)}
                            />
                            <Box3Items>
                                <InputResponsive1
                                    type='text' title={getTitleIndex("Identificação única (gerada pelo Inep)", 'inep')}
                                    register={register("inep")}
                                    maxlength='12'
                                    value={onlyNumber(Identificacao?.inep)}
                                    {...setValue('inep', Identificacao?.inep)}
                                    onChange={e => setIdentificacao({ ...Identificacao, inep: e.target.value })}
                                    erro={errors.inep?.message} />
                            </Box3Items>
                        </FormContent>
                        <FormContent >
                            <Box3Items>
                                <Box25>
                                    <InputResponsive1
                                        className='cpf'
                                        id='cpf'
                                        maxlength='14'
                                        title={getTitleIndex("Número do CPF", 'cpf')} mandatory='*'
                                        name='cpf'
                                        {...setValue('cpf', Identificacao?.cpf)}
                                        value={cpfMask(Identificacao?.cpf)}
                                        register={register('cpf')}
                                        erro={errors.cpf?.message}
                                        onChange={e => setIdentificacao({ ...Identificacao, cpf: e.target.value })} />
                                </Box25>
                            </Box3Items>
                            <BoxInput>
                                <InputResponsive1 name='completeName' title={getTitleIndex("Nome completo", 'completeName')} mandatory='*'
                                    register={register('completeName')}
                                    value={onlyText(Identificacao?.completeName)}
                                    {...setValue('completeName', Identificacao?.completeName)}
                                    erro={errors.completeName?.message}
                                    onChange={e => setIdentificacao({ ...Identificacao, completeName: e.target.value.toUpperCase() })} />
                            </BoxInput>
                            <Box3Items>
                                <Box25>
                                    <InputResponsive1 name='birthDate' type='date' title={getTitleIndex("Data de nascimento", 'birthDate')} mandatory='*'
                                        register={register('birthDate')}
                                        {...setValue('birthDate', Identificacao?.birthDate)}
                                        erro={errors.birthDate?.message}
                                        onChange={e => setIdentificacao({ ...Identificacao, birthDate: e.target.value })} />
                                </Box25>
                                <Box50>
                                    <TitleFieldForm>
                                        {getTitleIndex("Filiação", 'filiation')} <Madatory>*</Madatory>
                                    </TitleFieldForm>
                                    <Select
                                        name='filiation'
                                        {...register('filiation')}
                                        value={Identificacao?.filiation.haveFiliation || 3}
                                        {...setValue('filiation', Identificacao?.filiation.haveFiliation ?? 0)}
                                        onChange={e => setIdentificacao({
                                            ...Identificacao, filiation: {
                                                ...Identificacao?.filiation,
                                                haveFiliation: Number(e.target.value)
                                            }
                                        })}>
                                        <Option value={3} disabled hidden>selecione</Option>
                                        <Option value={0}>Não declarado/Ignorado</Option>
                                        <Option value={1}>Filiação 1 e/ou Filiação 2</Option>
                                    </Select>
                                    <Message>{errors.filiation?.message}</Message>
                                </Box50>
                            </Box3Items>
                            <Box3Items style={{ display: Identificacao?.filiation.haveFiliation !== 1 ? 'none' : 'flex' }}>
                                <Box50>
                                    <InputResponsive1 title={"Filiação 1"} mandatory='*'
                                        {...setValue('responsible1', Identificacao?.filiation.responsible1)}
                                        register={register('responsible1')}
                                        erro={errors.responsible1?.message}
                                        onChange={e => setIdentificacao({
                                            ...Identificacao, filiation: {
                                                ...Identificacao?.filiation,
                                                responsible1: e.target.value.toUpperCase()
                                            }
                                        })} />
                                </Box50>
                                <Box50>
                                    <InputResponsive1 title={"Filiação 2"}
                                        name='responsible2'
                                        erro={errors.responsible2?.message}
                                        {...setValue('responsible2', Identificacao?.filiation.responsible2)}
                                        register={register('responsible2')}
                                        onChange={e => setIdentificacao({
                                            ...Identificacao, filiation: {
                                                ...Identificacao?.filiation,
                                                responsible2: e.target.value.toUpperCase()
                                            }
                                        })} />
                                </Box50>
                            </Box3Items>
                            <Box3Items>
                                <Box25>
                                    <TitleFieldForm>
                                        {getTitleIndex("Sexo", 'sex')} <Madatory>*</Madatory>
                                    </TitleFieldForm>
                                    <Select
                                        name='sex'
                                        {...register('sex')}
                                        value={Identificacao?.sex ?? 0}
                                        {...setValue('sex', Identificacao?.sex ?? 0)}
                                        onChange={e => setIdentificacao({ ...Identificacao, sex: Number(e.target.value) })}>
                                        <Option value={0} disabled hidden>selecione</Option>
                                        <Option value={1}>Masculino</Option>
                                        <Option value={2}>Feminino</Option>
                                    </Select>
                                    <Message>{errors.sex?.message}</Message>
                                </Box25>
                                <Box25 >
                                    <TitleFieldForm>
                                        {getTitleIndex("Cor/Raça", 'colorRace')} <Madatory>*</Madatory>
                                    </TitleFieldForm>
                                    <Select
                                        name='colorRace'
                                        value={Identificacao?.colorRace ?? -1}
                                        {...register('colorRace')}
                                        {...setValue('colorRace', Identificacao?.colorRace ?? -1)}
                                        onChange={e => setIdentificacao({ ...Identificacao, colorRace: Number(e.target.value) })}>
                                        <Option value={-1} disabled hidden>selecione</Option>
                                        <Option value={0}>Não declarado</Option>
                                        <Option value={1}>Branca</Option>
                                        <Option value={2}>Preta</Option>
                                        <Option value={3}>Parda</Option>
                                        <Option value={4}>Amarela</Option>
                                        <Option value={5}>Indigena</Option>
                                    </Select>
                                    <Message>{errors.colorRace?.message}</Message>
                                </Box25>
                                <Box25 style={{ display: Identificacao?.colorRace === 5 ? 'block' : 'none' }}>
                                    <TitleFieldForm>
                                        {getTitleIndex("Povo indígena", 'indigenousPeople', Identificacao?.colorRace === 5)} <Madatory>*</Madatory>
                                    </TitleFieldForm>
                                    <Select
                                        name='indigenousPeople'
                                        value={Identificacao?.colorRace ?? -1}
                                        {...register('indigenousPeople')}
                                        {...setValue('indigenousPeople', Identificacao?.indigenousPeople ?? - 1)}
                                        onChange={e => setIdentificacao({ ...Identificacao, indigenousPeople: Number(e.target.value) })}>
                                        <Option value={-1} disabled hidden>selecione</Option>
                                        <Option value={0}>Não declarado</Option>
                                        <Option value={1}>Branca</Option>
                                        <Option value={2}>Preta</Option>
                                        <Option value={3}>Parda</Option>
                                        <Option value={4}>Amarela</Option>
                                        <Option value={5}>Indigena</Option>
                                    </Select>
                                    <Message>{errors.indigenousPeople?.message}</Message>
                                </Box25>
                            </Box3Items>
                            <Box2Items>
                                <Box50>
                                    <TitleFieldForm>
                                        {getTitleIndex("Nacionalidade", 'nationality')} <Madatory>*</Madatory>
                                    </TitleFieldForm>
                                    <Select
                                        {...setValue('nationality', Identificacao?.nationality ?? 'DEFAULT')}
                                        name='nationality'
                                        value={Identificacao?.nationality || 0}
                                        {...register('nationality')}
                                        onChange={e => setIdentificacao({ ...Identificacao, nationality: Number(e.target.value) })} >
                                        <Option value={0} disabled hidden>selecione</Option>
                                        <Option key={1} value={1}>Brasileira</Option>
                                        <Option key={2} value={2}>Brasileira - nascido no Exterior ou Naturalizado</Option>
                                        <Option key={3} value={3}>Estrangeira</Option>
                                    </Select>
                                    <Message>{errors.nationality?.message}</Message>
                                </Box50>
                                <Box50>
                                    <TitleFieldForm>
                                        {getTitleIndex("Pais de Nacionalidade", 'nationalityCountry')} <Madatory>*</Madatory>
                                    </TitleFieldForm>
                                    <Select
                                        value={Identificacao?.nationalityCountry ?? 0}
                                        name='nationalityCountry'
                                        {...register('nationalityCountry')}
                                        {...setValue('nationalityCountry', Identificacao?.nationalityCountry ?? 0)}
                                        disabled={Identificacao?.nationality !== 6 ? false : true}
                                        onChange={e => setIdentificacao({ ...Identificacao, nationalityCountry: Number(e.target.value) })}  >
                                        <Option value={0} disabled hidden>selecione</Option>
                                        {listCountry.map(function (key, value) {
                                            if (Identificacao?.nationality === 1) {
                                                if (key.name === 'Brasil')
                                                    return <Option key={key.id + key.name} selected value={key.ddi}>{key.name}</Option>;
                                            }
                                            else {
                                                return <Option key={key.id + key.name} value={key.ddi}>{key.name}</Option>;
                                            }
                                        })}
                                    </Select>
                                    <Message>{errors.nationalityCountry?.message}</Message>
                                </Box50>
                            </Box2Items>
                            <Box3Items style={{ display: Identificacao?.nationality === 1 ? 'flex' : 'none' }} >
                                <Box30>
                                    <TitleFieldForm>
                                        {getTitleIndex("UF de nascimento", 'uf', Identificacao?.nationality === 1)} <Madatory>*</Madatory>
                                    </TitleFieldForm>
                                    <Select
                                        name='uf'
                                        {...register('uf')}
                                        value={Identificacao?.uf || 0}
                                        {...setValue('uf', Identificacao?.uf ?? '')}
                                        onChange={e => setIdentificacao({ ...Identificacao, uf: e.target.value })}>
                                        <Option value={0} disabled hidden>selecione</Option>
                                        {Object.values(listUf).map(function (key, value) {
                                            return (

                                                <Option key={key} value={key}>{key}</Option>
                                            )
                                        })}
                                    </Select>
                                    <Message>{errors.uf?.message}</Message>
                                </Box30>
                                <Box50>
                                    <TitleFieldForm>
                                        {getTitleIndex("Municipio de Nascimento", 'cityBorn', Identificacao?.nationality === 1)} <Madatory>*</Madatory>
                                    </TitleFieldForm>
                                    <Select
                                        name='cityBorn'

                                        {...register('cityBorn')}
                                        {...setValue('cityBorn', Identificacao?.cityBorn || 0)}
                                        value={Identificacao?.cityBorn || 0}
                                        // disabled={Identificacao?.nationality === 1 ? false : true}
                                        onChange={e => setIdentificacao({ ...Identificacao, cityBorn: Number(e.target.value) })}>
                                        <Option key={"CityBorn0"} value={0} disabled hidden>Selecione</Option>
                                        {aux.map(function (key, index) {
                                            return <Option key={key.code} value={key.code}  >{key.name}</Option>


                                        })}
                                    </Select>
                                    <Message>{errors.cityBorn?.message}</Message>
                                </Box50>
                            </Box3Items>
                        </FormContent>
                        <FormContent>
                            <BoxInput>
                                <TitleFieldForm>
                                    {getTitleIndex("Pessoa física com deficiência, transtorno do espectro autista e altas habilidades ou superdotação", 'existsDeficiencyDisorder')} <Madatory>*</Madatory>
                                </TitleFieldForm>
                                <Box3Items className='box-radio'>
                                    <input type='radio' className='radio' name='existsDeficiencyDisorder' {...register('existsDeficiencyDisorder')} {...setValue('existsDeficiencyDisorder', Identificacao?.existsDeficiencyDisorder ?? 0)} title='Sim' id="yes" value={1} onChange={(e) => setExistsDeficiency(1)} checked={Number(Identificacao?.existsDeficiencyDisorder) === 1} /><label className='info-radio'>Sim</label>
                                    <input type='radio' className='radio' name='existsDeficiencyDisorder' {...register('existsDeficiencyDisorder')}  {...setValue('existsDeficiencyDisorder', Identificacao?.existsDeficiencyDisorder ?? 0)} title='Não' id="no" value={0} onChange={(e) => setExistsDeficiency(0)} checked={Number(Identificacao?.existsDeficiencyDisorder) === 0} /> <label className='info-radio'>Não</label>
                                </Box3Items>
                            </BoxInput>
                            <FormContent style={{ display: Number(Identificacao?.existsDeficiencyDisorder) === 1 ? 'flex' : 'none' }}>

                                <Box2Items style={{}}>
                                    <Box>
                                        <TitleFieldForm>Tipo de deficiência, transtorno do espectro autista e altas habilidades ou superdotação</TitleFieldForm>
                                        <Message style={{ display: !errors.deficiencyDisorder ? 'none' : 'flex' }}>escolha pelo menos uma das opções</Message>
                                        <Checkbox title='Baixa visão'
                                            name='deficiencyDisorder[0]'
                                            setValue={setValue('deficiencyDisorder[0]', Identificacao?.deficiencyDisorder.lowVision ?? 0)}
                                            register={register("deficiencyDisorder[0]")}
                                            className='lowVision'
                                            checked={Identificacao?.deficiencyDisorder.lowVision === 1 && Identificacao?.existsDeficiencyDisorder === 1 ? true : false}
                                            onChange={e => {
                                                setIdentificacao({
                                                    ...Identificacao, deficiencyDisorder: {
                                                        ...Identificacao?.deficiencyDisorder,
                                                        lowVision: e.target.checked === true ? 1 : 0,
                                                        blindness: 0,
                                                        deafBlindness: 0
                                                    }
                                                })
                                            }}
                                        />
                                        <Checkbox title='Visão monocular'
                                            name='deficiencyDisorder[10]'
                                            setValue={setValue('deficiencyDisorder[10]', Identificacao?.deficiencyDisorder.monocularVision ?? 0)}
                                            register={register("deficiencyDisorder[10]")}
                                            className='lowVision'
                                            checked={Identificacao?.deficiencyDisorder.monocularVision === 1 && Identificacao?.existsDeficiencyDisorder === 1 ? true : false}
                                            onChange={e => {
                                                setIdentificacao({
                                                    ...Identificacao, deficiencyDisorder: {
                                                        ...Identificacao?.deficiencyDisorder,
                                                        monocularVision: e.target.checked === true ? 1 : 0,
                                                        blindness: 0,
                                                        deafBlindness: 0
                                                    }
                                                })
                                            }} />
                                        <Checkbox title='Cegueira'
                                            name='deficiencyDisorder[1]'
                                            setValue={setValue('deficiencyDisorder[1]', Identificacao?.deficiencyDisorder.blindness ?? 0)}
                                            value={Identificacao?.deficiencyDisorder.blindness}
                                            register={register("deficiencyDisorder[1]")}
                                            checked={Identificacao?.deficiencyDisorder.blindness === 1 ? true : false}
                                            onChange={e => {
                                                setIdentificacao({
                                                    ...Identificacao, deficiencyDisorder: {
                                                        ...Identificacao?.deficiencyDisorder,
                                                        blindness: e.target.checked ? 1 : 0,
                                                        lowVision: 0,
                                                        deafness: 0,
                                                        deafBlindness: 0,
                                                    }
                                                });
                                            }}
                                        />
                                        <Checkbox title='Deficiência auditiva'
                                            name='deficiencyDisorder[2]'
                                            setValue={setValue('deficiencyDisorder[2]', Identificacao?.deficiencyDisorder.hearingDeficiency ?? 0)}
                                            register={register("deficiencyDisorder[2]")}
                                            value={Identificacao?.deficiencyDisorder.hearingDeficiency}
                                            checked={Identificacao?.deficiencyDisorder.hearingDeficiency === 1 ? true : false}
                                            onChange={e => {
                                                setIdentificacao({
                                                    ...Identificacao, deficiencyDisorder: {
                                                        ...Identificacao?.deficiencyDisorder,
                                                        hearingDeficiency: e.target.checked ? 1 : 0,
                                                        deafness: 0,
                                                        deafBlindness: 0
                                                    }
                                                });
                                            }}
                                        />
                                        <Checkbox title='Deficiência física'
                                            name='deficiencyDisorder[3]'
                                            setValue={setValue('deficiencyDisorder[3]', Identificacao?.deficiencyDisorder.physicalDisability ?? 0)}
                                            register={register("deficiencyDisorder[3]")}
                                            checked={Identificacao?.deficiencyDisorder.physicalDisability === 1 ? true : false}
                                            onChange={e => {
                                                setIdentificacao({
                                                    ...Identificacao, deficiencyDisorder: {
                                                        ...Identificacao?.deficiencyDisorder,
                                                        physicalDisability: e.target.checked ? 1 : 0
                                                    }
                                                });
                                            }}
                                        />
                                        <Checkbox title='Deficiência intelectual'
                                            name='deficiencyDisorder[4]'
                                            setValue={setValue('deficiencyDisorder[4]', Identificacao?.deficiencyDisorder.intellectualDisability ?? 0)}
                                            register={register("deficiencyDisorder[4]")}
                                            value={Identificacao?.deficiencyDisorder.intellectualDisability}
                                            checked={Identificacao?.deficiencyDisorder.intellectualDisability === 1 ? true : false}
                                            onChange={e => {
                                                setIdentificacao({
                                                    ...Identificacao, deficiencyDisorder: {
                                                        ...Identificacao?.deficiencyDisorder,
                                                        intellectualDisability: e.target.checked ? 1 : 0
                                                    }
                                                });
                                            }}
                                        />
                                        <Checkbox title='Surdez'
                                            name='deficiencyDisorder[5]'
                                            setValue={setValue('deficiencyDisorder[5]', Identificacao?.deficiencyDisorder.deafness ?? 0)}
                                            register={register("deficiencyDisorder[5]")}
                                            value={Identificacao?.deficiencyDisorder}
                                            checked={Identificacao?.deficiencyDisorder.deafness === 1 ? true : false}
                                            onChange={e => {
                                                setIdentificacao({
                                                    ...Identificacao, deficiencyDisorder: {
                                                        ...Identificacao?.deficiencyDisorder,
                                                        deafness: e.target.checked ? 1 : 0,
                                                        blindness: 0,
                                                        hearingDeficiency: 0,
                                                        deafBlindness: 0,
                                                    }
                                                });
                                            }}
                                        />
                                        <Checkbox title='Surdocegueira'
                                            name='deficiencyDisorder[6]'
                                            setValue={setValue('deficiencyDisorder[6]', Identificacao?.deficiencyDisorder.deafBlindness ?? 0)}
                                            register={register("deficiencyDisorder[6]")}
                                            value={Identificacao?.deficiencyDisorder.deafBlindness}
                                            checked={Identificacao?.deficiencyDisorder.deafBlindness === 1 ? true : false}
                                            onChange={e => {
                                                setIdentificacao({
                                                    ...Identificacao, deficiencyDisorder: {
                                                        ...Identificacao?.deficiencyDisorder,
                                                        deafBlindness: e.target.checked ? 1 : 0,
                                                        blindness: 0,
                                                        deafness: 0,
                                                        hearingDeficiency: 0
                                                    }
                                                });
                                            }}
                                        />
                                        {/*
                            aplicar a regra quando tiver mais de 1 campo habilitado desse formulario deficiencia
                            deverá ser marcado com '1' , caso contrario '0'
                            */}
                                        <Checkbox title='Deficiência multipla'
                                            name='deficiencyDisorder[7]'
                                            setValue={setValue('deficiencyDisorder[7]', Identificacao?.deficiencyDisorder.multipleDisability ?? 0)}
                                            register={register("deficiencyDisorder[7]")}
                                            value={Identificacao?.deficiencyDisorder.multipleDisability}
                                            checked={Identificacao?.deficiencyDisorder.multipleDisability === 1 ? true : false}
                                            onChange={e => {
                                                setIdentificacao({
                                                    ...Identificacao, deficiencyDisorder: {
                                                        ...Identificacao?.deficiencyDisorder,
                                                        multipleDisability: e.target.checked ? 1 : 0
                                                    }
                                                });
                                            }}
                                        />
                                    </Box>
                                    <Box>
                                        <TitleFieldForm>
                                            Transtorno do espectro autista
                                        </TitleFieldForm>
                                        <Checkbox title='Transtorno do espectro autista'
                                            name='deficiencyDisorder[8]'
                                            setValue={setValue('deficiencyDisorder[8]', Identificacao?.deficiencyDisorder.autisticSpectrumDisorder ?? 0)}
                                            register={register("deficiencyDisorder[8]")}
                                            value={Identificacao?.deficiencyDisorder.autisticSpectrumDisorder}
                                            checked={Identificacao?.deficiencyDisorder.autisticSpectrumDisorder === 1 ? true : false}
                                            onChange={e => {
                                                setIdentificacao({
                                                    ...Identificacao, deficiencyDisorder: {
                                                        ...Identificacao?.deficiencyDisorder,
                                                        autisticSpectrumDisorder: e.target.checked ? 1 : 0
                                                    }
                                                });
                                            }}
                                        />
                                    </Box>
                                    <Box>
                                        <TitleFieldForm>
                                            Altas habilidades/superdotação
                                        </TitleFieldForm>
                                        <Checkbox title='Altas habilidades/superdotação'
                                            name='deficiencyDisorder[9]'
                                            setValue={setValue('deficiencyDisorder[9]', Identificacao?.deficiencyDisorder.highSkills ?? 0)}
                                            register={register("deficiencyDisorder[9]")}
                                            value={Identificacao?.deficiencyDisorder.highSkills}
                                            checked={Identificacao?.deficiencyDisorder.highSkills === 1 ? true : false}
                                            onChange={e => {
                                                setIdentificacao({
                                                    ...Identificacao, deficiencyDisorder: {
                                                        ...Identificacao?.deficiencyDisorder,
                                                        highSkills: e.target.checked ? 1 : 0
                                                    }
                                                });
                                            }}
                                        />
                                    </Box>
                                </Box2Items>
                            </FormContent>

                            <BoxInput>
                                <TitleFieldForm>
                                    {getTitleIndex("Pessoa física com transtorno(s) que impacta(m) o desenvolvimento da aprendizagem", 'existsImpactfulLearningDisorder')} <Madatory>*</Madatory>
                                </TitleFieldForm>
                                <Box3Items className='box-radio'>
                                    <input type='radio' className='radio' name='existsImpactfulLearningDisorder' {...register('existsImpactfulLearningDisorder')} {...setValue('existsImpactfulLearningDisorder', Identificacao?.existsImpactfulLearningDisorder ?? 0)} title='Sim' id="yes" value={1} onChange={(e) => setExistsImpactfulLearningDisorder(1)} checked={Number(Identificacao?.existsImpactfulLearningDisorder) === 1} /><label className='info-radio'>Sim</label>
                                    <input type='radio' className='radio' name='existsImpactfulLearningDisorder' {...register('existsImpactfulLearningDisorder')}  {...setValue('existsImpactfulLearningDisorder', Identificacao?.existsImpactfulLearningDisorder ?? 0)} title='Não' id="no" value={0} onChange={(e) => setExistsImpactfulLearningDisorder(0)} checked={Number(Identificacao?.existsImpactfulLearningDisorder) === 0} /> <label className='info-radio'>Não</label>
                                </Box3Items>
                            </BoxInput>

                            <FormContent style={{ display: Number(Identificacao?.existsImpactfulLearningDisorder) === 1 ? 'flex' : 'none' }}>

                                <Box2Items style={{}}>
                                    <Box>
                                        <TitleFieldForm>Tipo(s) de transtorno(s) que impacta(m) o desenvolvimento da aprendizagem</TitleFieldForm>
                                        <Message style={{ display: !errors.existsImpactfulLearningDisorder ? 'none' : 'flex' }}>escolha pelo menos uma das opções</Message>
                                        <Checkbox title='Discalculia ou outro transtorno da matemática e raciocínio lógico'
                                            name='impactfulLearningDisorder[0]'
                                            setValue={setValue('impactfulLearningDisorder[0]', Identificacao?.impactfulLearningDisorder.dyscalculia ?? 0)}
                                            register={register("impactfulLearningDisorder[0]")}
                                            className='dyscalculia'
                                            checked={Identificacao?.impactfulLearningDisorder.dyscalculia === 1 && Identificacao?.existsImpactfulLearningDisorder === 1 ? true : false}
                                            onChange={e => {
                                                setIdentificacao({
                                                    ...Identificacao, impactfulLearningDisorder: {
                                                        ...Identificacao?.impactfulLearningDisorder,
                                                        dyscalculia: e.target.checked === true ? 1 : 0,
                                                    }
                                                })
                                            }}
                                        />
                                        <Checkbox title='Disgrafia, Disortografia ou outro transtorno da escrita e ortografia'
                                            name='impactfulLearningDisorder[0]'
                                            setValue={setValue('impactfulLearningDisorder[0]', Identificacao?.impactfulLearningDisorder.dysgraphia ?? 0)}
                                            register={register("impactfulLearningDisorder[0]")}
                                            className='dysgraphia'
                                            checked={Identificacao?.impactfulLearningDisorder.dysgraphia === 1 && Identificacao?.existsImpactfulLearningDisorder === 1 ? true : false}
                                            onChange={e => {
                                                setIdentificacao({
                                                    ...Identificacao, impactfulLearningDisorder: {
                                                        ...Identificacao?.impactfulLearningDisorder,
                                                        dysgraphia: e.target.checked === true ? 1 : 0,
                                                    }
                                                })
                                            }}
                                        />
                                        <Checkbox title='Dislalia ou outro transtorno da linguagem e comunicação'
                                            name='impactfulLearningDisorder[0]'
                                            setValue={setValue('impactfulLearningDisorder[0]', Identificacao?.impactfulLearningDisorder.dyslalia ?? 0)}
                                            register={register("impactfulLearningDisorder[0]")}
                                            className='dyslalia'
                                            checked={Identificacao?.impactfulLearningDisorder.dyslalia === 1 && Identificacao?.existsImpactfulLearningDisorder === 1 ? true : false}
                                            onChange={e => {
                                                setIdentificacao({
                                                    ...Identificacao, impactfulLearningDisorder: {
                                                        ...Identificacao?.impactfulLearningDisorder,
                                                        dyslalia: e.target.checked === true ? 1 : 0,
                                                    }
                                                })
                                            }}
                                        />
                                        <Checkbox title='Dislexia'
                                            name='impactfulLearningDisorder[0]'
                                            setValue={setValue('impactfulLearningDisorder[0]', Identificacao?.impactfulLearningDisorder.dyslexia ?? 0)}
                                            register={register("impactfulLearningDisorder[0]")}
                                            className='dyslexia'
                                            checked={Identificacao?.impactfulLearningDisorder.dyslexia === 1 && Identificacao?.existsImpactfulLearningDisorder === 1 ? true : false}
                                            onChange={e => {
                                                setIdentificacao({
                                                    ...Identificacao, impactfulLearningDisorder: {
                                                        ...Identificacao?.impactfulLearningDisorder,
                                                        dyslexia: e.target.checked === true ? 1 : 0,
                                                    }
                                                })
                                            }}
                                        />
                                        <Checkbox title='Transtorno do Déficit de Atenção com Hiperatividade (TDAH)'
                                            name='impactfulLearningDisorder[0]'
                                            setValue={setValue('impactfulLearningDisorder[0]', Identificacao?.impactfulLearningDisorder.TDAH ?? 0)}
                                            register={register("impactfulLearningDisorder[0]")}
                                            className='TDAH'
                                            checked={Identificacao?.impactfulLearningDisorder.TDAH === 1 && Identificacao?.existsImpactfulLearningDisorder === 1 ? true : false}
                                            onChange={e => {
                                                setIdentificacao({
                                                    ...Identificacao, impactfulLearningDisorder: {
                                                        ...Identificacao?.impactfulLearningDisorder,
                                                        TDAH: e.target.checked === true ? 1 : 0,
                                                    }
                                                })
                                            }}
                                        />
                                        <Checkbox title='Transtorno do Processamento Auditivo Central (TPAC)'
                                            name='impactfulLearningDisorder[0]'
                                            setValue={setValue('impactfulLearningDisorder[0]', Identificacao?.impactfulLearningDisorder.TPAC ?? 0)}
                                            register={register("impactfulLearningDisorder[0]")}
                                            className='TPAC'
                                            checked={Identificacao?.impactfulLearningDisorder.TPAC === 1 && Identificacao?.existsImpactfulLearningDisorder === 1 ? true : false}
                                            onChange={e => {
                                                setIdentificacao({
                                                    ...Identificacao, impactfulLearningDisorder: {
                                                        ...Identificacao?.impactfulLearningDisorder,
                                                        TPAC: e.target.checked === true ? 1 : 0,
                                                    }
                                                })
                                            }}
                                        />
                                    </Box>
                                </Box2Items>
                            </FormContent>
                            <BoxInput style={{ display: Number(Identificacao?.existsDeficiencyDisorder) === 1 || Number(Identificacao?.existsImpactfulLearningDisorder === 1) ? 'block' : 'none' }}>
                                <TitleFieldForm>{getTitleIndex(" Recursos para uso do(a) aluno(a) em sala de aula e para participação em avaliações do Inep (Saeb)", 'resourceEvaluationInep', Number(Identificacao?.existsDeficiencyDisorder) === 1 || Number(Identificacao?.existsImpactfulLearningDisorder === 1))}<Madatory>*</Madatory></TitleFieldForm>
                                <Message style={{ display: !errors.resourceEvaluationInep ? 'none' : 'flex' }}>escolha pelo menos uma das opções</Message>
                                <Box>
                                    <Checkbox title='Auxílio ledor'
                                        id='resource'
                                        name="resourceEvaluationInep[0]"
                                        setValue={setValue('resourceEvaluationInep[0]', Identificacao?.resourceEvaluationInep.readingAid ?? null)}
                                        register={register("resourceEvaluationInep[0]")}
                                        checked={Identificacao?.resourceEvaluationInep.readingAid === 1 ? true : false}
                                        onChange={e => {
                                            setIdentificacao({
                                                ...Identificacao, resourceEvaluationInep: {
                                                    ...Identificacao?.resourceEvaluationInep,
                                                    readingAid: e.target.checked ? 1 : 0,
                                                    none: 0
                                                }
                                            });
                                        }}
                                    />
                                    <Checkbox title='Auxilio transcrição'
                                        name="resourceEvaluationInep[1]"
                                        setValue={setValue('resourceEvaluationInep[1]', Identificacao?.resourceEvaluationInep.transcriptionAssistance ?? null)}
                                        register={register("resourceEvaluationInep[1]")}
                                        checked={Identificacao?.resourceEvaluationInep.transcriptionAssistance === 1 ? true : false}
                                        onChange={e => setIdentificacao({
                                            ...Identificacao, resourceEvaluationInep: {
                                                ...Identificacao?.resourceEvaluationInep,
                                                transcriptionAssistance: e.target.checked ? 1 : 0,
                                                none: 0
                                            }
                                        })}
                                    />
                                    <Checkbox title='Guia-inteprete'
                                        name="resourceEvaluationInep[2]"
                                        setValue={setValue('resourceEvaluationInep[2]', Identificacao?.resourceEvaluationInep.interpreterGuide ?? null)}
                                        register={register("resourceEvaluationInep[2]")}
                                        checked={Identificacao?.resourceEvaluationInep.interpreterGuide === 1 ? true : false}
                                        onChange={e => {
                                            setIdentificacao({
                                                ...Identificacao, resourceEvaluationInep: {
                                                    ...Identificacao?.resourceEvaluationInep,
                                                    interpreterGuide: e.target.checked ? 1 : 0,
                                                    none: 0
                                                }
                                            });
                                        }}
                                    />
                                    <Checkbox title='Tradutor-intérprete de Libras'
                                        name="resourceEvaluationInep[3]"
                                        setValue={setValue('resourceEvaluationInep[3]', Identificacao?.resourceEvaluationInep.translatorInterpreterLibras ?? null)}
                                        register={register("resourceEvaluationInep[3]")}
                                        checked={Identificacao?.resourceEvaluationInep.translatorInterpreterLibras === 1 ? true : false}
                                        onChange={e => {
                                            setIdentificacao({
                                                ...Identificacao, resourceEvaluationInep: {
                                                    ...Identificacao?.resourceEvaluationInep,
                                                    translatorInterpreterLibras: e.target.checked ? 1 : 0,
                                                    none: 0
                                                }
                                            });
                                        }}
                                    />
                                    <Checkbox title='Leitura labial'
                                        name="resourceEvaluationInep[4]"
                                        setValue={setValue('resourceEvaluationInep[4]', Identificacao?.resourceEvaluationInep.lipReading ?? null)}
                                        register={register("resourceEvaluationInep[4]")}
                                        checked={Identificacao?.resourceEvaluationInep.lipReading === 1 ? true : false}
                                        onChange={e => {
                                            setIdentificacao({
                                                ...Identificacao, resourceEvaluationInep: {
                                                    ...Identificacao?.resourceEvaluationInep,
                                                    lipReading: e.target.checked ? 1 : 0,
                                                    none: 0
                                                }
                                            });
                                        }}
                                    />
                                    <Checkbox title='Material didático em Braille'
                                        name="resourceEvaluationInep[5]"
                                        setValue={setValue('resourceEvaluationInep[5]', Identificacao?.resourceEvaluationInep.teachingMaterialBraille ?? null)}
                                        register={register("resourceEvaluationInep[5]")}
                                        checked={Identificacao?.resourceEvaluationInep.teachingMaterialBraille === 1 ? true : false}
                                        onChange={e => {
                                            setIdentificacao({
                                                ...Identificacao, resourceEvaluationInep: {
                                                    ...Identificacao?.resourceEvaluationInep,
                                                    teachingMaterialBraille: e.target.checked ? 1 : 0,
                                                    none: 0
                                                }
                                            });
                                        }}
                                    />
                                    <Checkbox title='Prova ampliada (Fonte 18)'
                                        name="resourceEvaluationInep[6]"
                                        setValue={setValue('resourceEvaluationInep[6]', Identificacao?.resourceEvaluationInep.extendedProof ?? null)}
                                        register={register("resourceEvaluationInep[6]")}
                                        checked={Identificacao?.resourceEvaluationInep.extendedProof === 1 ? true : false}
                                        onChange={e => {
                                            setIdentificacao({
                                                ...Identificacao, resourceEvaluationInep: {
                                                    ...Identificacao?.resourceEvaluationInep,
                                                    extendedProof: e.target.checked ? 1 : 0,
                                                    none: 0
                                                }
                                            });
                                        }}
                                    />
                                    <Checkbox title='Prova superampliada (Fonte 24)'
                                        name="resourceEvaluationInep[7]"
                                        setValue={setValue('resourceEvaluationInep[7]', Identificacao?.resourceEvaluationInep.overenlargedProof ?? null)}
                                        register={register("resourceEvaluationInep[7]")}
                                        checked={Identificacao?.resourceEvaluationInep.overenlargedProof === 1 ? true : false}
                                        onChange={e => {
                                            setIdentificacao({
                                                ...Identificacao, resourceEvaluationInep: {
                                                    ...Identificacao?.resourceEvaluationInep,
                                                    overenlargedProof: e.target.checked ? 1 : 0,
                                                    none: 0
                                                }
                                            });
                                        }}
                                    />
                                    <Checkbox title='CD com áudio para  deficiente visual'
                                        name="resourceEvaluationInep[8]"
                                        setValue={setValue('resourceEvaluationInep[8]', Identificacao?.resourceEvaluationInep.cdVisuallyImpaired ?? null)}
                                        register={register("resourceEvaluationInep[8]")}
                                        checked={Identificacao?.resourceEvaluationInep.cdVisuallyImpaired === 1 ? true : false}
                                        onChange={e => {
                                            setIdentificacao({
                                                ...Identificacao, resourceEvaluationInep: {
                                                    ...Identificacao?.resourceEvaluationInep,
                                                    cdVisuallyImpaired: e.target.checked ? 1 : 0,
                                                    none: 0
                                                }
                                            });
                                        }}
                                    />
                                    <Checkbox title='Prova de Língua como Segunda língua para surdos e deficientes auditivos'
                                        name="resourceEvaluationInep[9]"
                                        setValue={setValue('resourceEvaluationInep[9]', Identificacao?.resourceEvaluationInep.secondLanguageDeafHearing ?? null)}
                                        register={register("resourceEvaluationInep[9]")}
                                        checked={Identificacao?.resourceEvaluationInep.secondLanguageDeafHearing === 1 ? true : false}
                                        onChange={e => {
                                            setIdentificacao({
                                                ...Identificacao, resourceEvaluationInep: {
                                                    ...Identificacao?.resourceEvaluationInep,
                                                    secondLanguageDeafHearing: e.target.checked ? 1 : 0,
                                                    none: 0
                                                }
                                            });
                                        }}
                                    />
                                    <Checkbox title='Prova de Vídeo em Libras'
                                        name="resourceEvaluationInep[10]"
                                        setValue={setValue('resourceEvaluationInep[10]', Identificacao?.resourceEvaluationInep.videoTestLibras ?? null)}
                                        register={register("resourceEvaluationInep[10]")}
                                        checked={Identificacao?.resourceEvaluationInep.videoTestLibras === 1 ? true : false}
                                        onChange={e => {
                                            setIdentificacao({
                                                ...Identificacao, resourceEvaluationInep: {
                                                    ...Identificacao?.resourceEvaluationInep,
                                                    videoTestLibras: e.target.checked ? 1 : 0,
                                                    none: 0

                                                }
                                            })
                                        }}
                                    />
                                    <Checkbox title='Prova em Braille'
                                        name="resourceEvaluationInep[11]"
                                        setValue={setValue('resourceEvaluationInep[11]', Identificacao?.resourceEvaluationInep.brailleTest ?? null)}
                                        register={register("resourceEvaluationInep[11]")}
                                        checked={Identificacao?.resourceEvaluationInep.brailleTest === 1 ? true : false}
                                        onChange={e => {
                                            setIdentificacao({
                                                ...Identificacao, resourceEvaluationInep: {
                                                    ...Identificacao?.resourceEvaluationInep,
                                                    brailleTest: e.target.checked ? 1 : 0,
                                                    none: 0

                                                }
                                            })
                                        }}
                                    />
                                    <Checkbox title='Tempo adicional'
                                        name="resourceEvaluationInep[12]"
                                        setValue={setValue('resourceEvaluationInep[12]', Identificacao?.resourceEvaluationInep.additionalTime ?? null)}
                                        register={register("resourceEvaluationInep[12]")}
                                        checked={Identificacao?.resourceEvaluationInep.additionalTime === 1 ? true : false}
                                        onChange={e => {
                                            setIdentificacao({
                                                ...Identificacao, resourceEvaluationInep: {
                                                    ...Identificacao?.resourceEvaluationInep,
                                                    additionalTime: e.target.checked ? 1 : 0,
                                                    none: 0

                                                }
                                            })
                                        }}
                                    />
                                    <Checkbox title='Nenhum'
                                        name="resourceEvaluationInep[11]"
                                        setValue={setValue('resourceEvaluationInep[11]', Identificacao?.resourceEvaluationInep.none ?? null)}
                                        register={register("resourceEvaluationInep[11]")}
                                        checked={Identificacao?.resourceEvaluationInep.none === 1 ? true : false}
                                        onChange={async e =>
                                            setIdentificacao({
                                                ...Identificacao, resourceEvaluationInep:
                                                    await IsNone(Identificacao?.resourceEvaluationInep, 'none')

                                            })
                                        }
                                    />
                                </Box>
                            </BoxInput>
                        </FormContent>
                        <ButtonFormFooter
                            textNext="Próximo"
                            linkBack={"/aluno/pesquisar"}
                        />
                    </form>
                </Container>
            </App>
        </>

    )

}
export default Identificacao;